export default __webpack_public_path__ + "static/media/105.3a459efe.gif";